module.exports = __webpack_public_path__ + "fonts/almoni-bold-aaa.5eb12cd.woff";